module.exports = __webpack_public_path__ + "static/img/11d.ef21e98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/11d.jpg
// module id = N6KI
// module chunks = 1